import React, { useState, useEffect } from "react";
import Modal from "../../../components/modal";
import { toast } from "react-hot-toast";
import api from "../../../services/api";

export function AddCourseModal({ onAdd, existingIds = [] }) {
  const [isOpen, setIsOpen] = useState(false);
  const [courses, setCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) fetchCourses();
  }, [isOpen]);

  async function fetchCourses() {
    setIsLoading(true);
    try {
      const { data, ok } = await api.post("/training/search");
      if (!ok) throw new Error();
      setCourses(data);
    } catch (error) {
      toast.error("Failed to fetch courses");
    } finally {
      setIsLoading(false);
    }
  }

  function handleSelect(course) {
    setIsOpen(false);
    onAdd && onAdd(course);
  }

  const filteredCourses = courses.filter((t) => !existingIds.includes(t._id));

  if (!isOpen)
    return (
      <button
        onClick={() => setIsOpen(true)}
        className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors">
        Add Course
      </button>
    );

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} className="max-w-2xl w-full p-6">
      <div className="p-4">
        <h2 className="text-lg font-semibold mb-4">Add Course to Career Path</h2>
        {isLoading ? (
          <div className="text-gray-500">Loading...</div>
        ) : (
          <div className="space-y-2 max-h-[60vh] overflow-y-auto">
            {filteredCourses.length === 0 && <div className="text-gray-500">No available courses to add.</div>}
            {filteredCourses.map((course) => (
              <div
                key={course._id}
                className="flex items-center justify-between bg-gray-50 border border-gray-200 rounded-lg p-3 hover:bg-blue-50 cursor-pointer"
                onClick={() => handleSelect(course)}>
                <div>
                  <div className="font-semibold text-gray-900">{course.title}</div>
                  <div className="text-sm text-gray-600 line-clamp-2">{course.description}</div>
                  <div className="text-xs text-gray-500 mt-1">{course.category || "TECH"}</div>
                </div>
                {course.image && <img src={course.image} alt={course.title} className="w-12 h-12 rounded object-cover ml-4" />}
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
}
